<template>
  <q-card flat bordered class="q-pa-lg q-pa-lg-xl more-rounded-borders" v-if="selected_tdsp">


    <div>
      <q-chip text-color="indigo-10" color="blue-1" class="text-bold q-ml-md"
              :label="`Showing ${ filtered_plans.length } of ${ total_plans } rates`"></q-chip>
    </div>

    <q-item style="font-size: 20px">
      <q-item-section avatar>
        <q-icon name="offline_bolt" class="text-bold"></q-icon>
      </q-item-section>
      <q-item-section>
        <q-item-label class="text-bold">
          {{ filtered_plans.length }} electric rates
        </q-item-label>
        <q-item-label class="text-100">
          {{ zip_code }} ({{ selected_tdsp.short_name }})
        </q-item-label>
      </q-item-section>
    </q-item>

    <q-btn icon="pin_drop" class="text-bold q-mb-sm" no-caps flat color="light-blue-5" label="Change Zip Code"
           @click="clear_zip_code"></q-btn>

    <q-card-section>
      <div class="text-100 text-bold q-mb-md">
        Quick filters
      </div>

      <div class="flex column items-start gt-xs q-gutter-y-xs">
        <q-btn flat no-caps
               icon="visibility"
               label="Show All"
               padding="xs none"
               :color="has_no_filters ? 'primary' : 'grey'"
               @click="clear_all_filters">
        </q-btn>

        <q-btn flat no-caps
               icon="hourglass_full"
               label="Long Term"
               padding="xs none"
               :color="has_long_term_filter ? 'primary' : 'grey'"
               @click="filter_long_term">
        </q-btn>

        <q-btn flat no-caps
               icon="energy_savings_leaf"
               label="Green"
               padding="xs none"
               :color="filters.only_100_percent_green.selected ? 'primary' : 'grey'"
               @click="filters.only_100_percent_green.selected = true">
        </q-btn>

        <q-btn flat no-caps
               icon="phonelink_erase"
               label="No Contract"
               padding="xs none"
               :color="has_no_contract_filter ? 'primary' : 'grey'"
               @click="filter_no_contract">
        </q-btn>

        <q-btn flat no-caps
               icon="credit_card_off"
               label="No Deposit"
               padding="xs none"
               :color="filters.only_no_deposit.selected ? 'primary' : 'grey'"
               @click="filters.only_no_deposit.selected = true">
        </q-btn>

      </div>

      <div class="flex justify-between lt-sm">

        <q-btn flat
               icon="clear_all"
               :color="has_no_filters ? 'primary' : 'grey'"
               @click="clear_all_filters">
          <q-tooltip>All Plans</q-tooltip>
        </q-btn>

        <q-btn flat
               icon="hourglass_full"
               :color="has_long_term_filter ? 'primary' : 'grey'"
               @click="filter_long_term">
          <q-tooltip>Long Term</q-tooltip>
        </q-btn>

        <q-btn flat
               icon="energy_savings_leaf"
               :color="filters.only_100_percent_green.selected ? 'primary' : 'grey'"
               @click="filters.only_100_percent_green.selected = true">
          <q-tooltip>Green</q-tooltip>
        </q-btn>

        <q-btn flat
               icon="lock_open"
               :color="has_no_contract_filter ? 'primary' : 'grey'"
               @click="filter_no_contract">
          <q-tooltip>No Contract</q-tooltip>
        </q-btn>

        <q-btn flat
               icon="local_atm"
               :color="filters.only_no_deposit.selected ? 'primary' : 'grey'"
               @click="filters.only_no_deposit.selected = true">
          <q-tooltip>No Deposit</q-tooltip>
        </q-btn>
      </div>
    </q-card-section>

    <q-card-section>
      <div class="text-100 text-bold">
        Sort By
      </div>
      <sort-option-select></sort-option-select>
    </q-card-section>

  </q-card>
</template>

<script>
import PlanFilters from "src/composables/PlanFilters";
import SortOptionSelect from "components/plans/filters/SortOptionSelect";
import Plans from "src/composables/Plans";
import Tdsps from "src/composables/Tdsps";

export default {
  name: "QuickFilter",
  components: { SortOptionSelect },
  setup() {
    const {
      has_no_filters,
      has_long_term_filter,
      has_no_contract_filter,
      clear_all_filters,
      filters,
      filter_long_term,
      filter_no_contract
    } = PlanFilters();

    const { filtered_plans, total_plans } = Plans()
    const { zip_code, selected_tdsp, clear_zip_code } = Tdsps();

    return {

      filters,

      has_no_filters,
      has_long_term_filter,
      has_no_contract_filter,

      zip_code,
      selected_tdsp,
      filtered_plans,
      total_plans,

      clear_zip_code,
      clear_all_filters,
      filter_long_term,
      filter_no_contract
    }
  }
}
</script>

<style scoped>

</style>
